import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "draivn-onboarding-info row full-height" }
const _hoisted_2 = {
  key: 0,
  class: "info-logo-block col-12"
}
const _hoisted_3 = { class: "drv-color-n0 drv-heading-lg" }
const _hoisted_4 = { class: "drv-color-n0 row self-end" }
const _hoisted_5 = { class: "drv-mb-16" }
const _hoisted_6 = { class: "drv-text-body-md drv-mb-1-5" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "drv-heading-lg drv-text-weight-medium" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "drv-heading-lg drv-text-weight-medium" }
const _hoisted_13 = { class: "col-12 drv-text-body-sm drv-color-b200" }

import { injector } from "@/services";
import { CONFIG_RENDER_SERVICE_INJECTION_KEY } from "@/constants";
import { EAppMessages } from "../../types";
import {
  LOGO_BLOCK_RENDER_FEATURE_KEY,
  SUPPORT_INFO_RENDER_FEATURE_KEY,
} from "../../constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoBlock',
  setup(__props) {

const configRenderService = injector.injectFromRoot(
  CONFIG_RENDER_SERVICE_INJECTION_KEY
);
const info = configRenderService.getConfig<{
  url: string;
  slogan: string;
}>(LOGO_BLOCK_RENDER_FEATURE_KEY);
const support = configRenderService.getConfig<{
  title: string;
  phone: string;
  link: {
    title: string;
    url: string;
  };
}>(SUPPORT_INFO_RENDER_FEATURE_KEY);
const year = new Date().getFullYear();

const logoUrl = `${process.env.VUE_APP_BASE_URL}${info?.url}`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(info))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", { class: "info-logo drv-mb-3" }, [
            _createElementVNode("img", {
              src: logoUrl,
              alt: "Logo"
            })
          ]),
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(info).slogan), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(support)?.title), 1),
        (_unref(support)?.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("a", {
                href: `tel:${_unref(support).phone}`,
                class: "drv-color-n0 drv-text-no-underline"
              }, [
                _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(support).phone), 1)
              ], 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true),
        (_unref(support)?.link)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", {
                href: _unref(support).link.url,
                class: "drv-color-n0"
              }, [
                _createElementVNode("h4", _hoisted_12, _toDisplayString(_unref(support).link.title), 1)
              ], 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(_unref(EAppMessages).DRAIVN_COPYRIGHT, { year: _unref(year) })), 1)
    ])
  ]))
}
}

})